export interface IAppConfiguration {
  culture: string;
  currencyCode: string;
  customerDiscount: number | null;
  xsrf: string;
  isAuthenticated: boolean;
  useBeforeVat: boolean;
}

export const getAppConfiguration = (): IAppConfiguration => (window as any).netbiz.configuration;

export const initAppConfiguration = () => {
  const html = document.querySelector('html') as HTMLElement;
  const configurationJson = html.dataset['reactConfiguration'];
  const configuration: IAppConfiguration = JSON.parse(configurationJson!);
  html.removeAttribute('data-react-configuration');

  const w = window as any;
  if (!('netbiz' in w)) w.netbiz = {};
  if (!('netbiz' in w.netbiz)) w.netbiz.configuration = {};
  w.netbiz.configuration = configuration;
};
